import axios from 'axios';
import { property } from 'lodash';
import { ImageLibraryConfig } from '@nextiva/engagement-ui';

import { generateApiError } from './utils/apiErrorMessages';
import {
  jsonApiHeaders,
  buildApiV2Url,
  toSurveyImagesSearchFilter,
} from './utils/apiUtils';
import { mapSurveyImageListFromApiModel } from './dataMapper/surveyImage';

export default ({
  offset = 0,
  limit = ImageLibraryConfig.libraryBatchSize,
  searchPhrase = '',
  sort = '-id',
}) =>
  axios
    .get(
      buildApiV2Url('images', {
        page: { limit, offset },
        filter: { ...toSurveyImagesSearchFilter(searchPhrase) },
        sort,
        include: 'entities',
      }),
      {
        headers: jsonApiHeaders,
      },
    )
    .catch(generateApiError())
    .then(property('data'))
    .then(mapSurveyImageListFromApiModel);
